import { render } from "./App.vue?vue&type=template&id=531931dc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=531931dc&lang=scss"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__